<section class="pdf-preview">
  <div class="pdf-preview__toolbar">
    <button mat-icon-button type="button" (click)="previous()" [disabled]="pageNumber() <= 1" aria-label="上一頁"><mat-icon>chevron_left</mat-icon></button>
    <span>{{ pageNumber() }} / {{ pageCount() }}</span>
    <button mat-icon-button type="button" (click)="next()" [disabled]="pageNumber() >= pageCount()" aria-label="下一頁"><mat-icon>chevron_right</mat-icon></button>
    <button mat-icon-button type="button" (click)="zoom(-0.25)" aria-label="縮小"><mat-icon>zoom_out</mat-icon></button>
    <span>{{ (scale() * 100).toFixed(0) }}%</span>
    <button mat-icon-button type="button" (click)="zoom(0.25)" aria-label="放大"><mat-icon>zoom_in</mat-icon></button>
    <button mat-button type="button" (click)="fitWidth()">符合寬度</button>
  </div>
  <div #stage class="pdf-preview__stage">
    @if (loading()) { <mat-spinner diameter="40"></mat-spinner> }
    @if (error()) { <p class="pdf-preview__error">{{ error() }}</p> }
    <canvas #canvas></canvas>
  </div>
</section>
